var map = {
	"./articles/1/1.jpg": "B9a5",
	"./articles/1/2.jpg": "I5pv",
	"./articles/1/3.jpg": "cfC1",
	"./articles/1/4.jpg": "cOEK",
	"./articles/1/5.jpg": "iEkw",
	"./articles/1/6.jpg": "bATW",
	"./articles/1/7.jpg": "16Kt",
	"./articles/2/1.jpg": "UsTp",
	"./articles/2/2.jpg": "h/oM",
	"./articles/2/3.jpg": "Cg7B",
	"./articles/2/4.jpg": "i4KG",
	"./articles/2/5.jpg": "b76/",
	"./articles/2/6.jpg": "mh07",
	"./articles/2/7.jpg": "Xf/R",
	"./articles/2/cover.jpg": "wCon",
	"./articles/2/cover.mp4": "ghET",
	"./articles/2/cover.ogv": "151s",
	"./articles/2/cover.webm": "jBHb",
	"./articles/3/cover.jpg": "QvKg",
	"./articles/4/1.jpg": "YpVv",
	"./articles/4/2.jpg": "p+OX",
	"./articles/4/3.jpg": "5HjG",
	"./articles/4/4.jpg": "kCYv",
	"./articles/4/cover.jpg": "Ib0G",
	"./articles/4/cover.mp4": "gATT",
	"./articles/4/cover.ogv": "JSuJ",
	"./articles/4/cover.webm": "BIcD",
	"./articles/5/cover.jpg": "k+oX",
	"./articles/6/1.jpg": "VqLw",
	"./articles/6/2.jpg": "8rl0",
	"./articles/6/cover.jpg": "BhhQ",
	"./articles/7/cover.jpg": "vFK/",
	"./articles/8/cover.jpg": "7Q2t",
	"./bad/sight.svg": "01UL",
	"./bad/slot.png": "X42g",
	"./bad/story1.mp4": "F+Jm",
	"./bad/story2.gif": "edij",
	"./bad/story3.gif": "0vMt",
	"./bad/story4.gif": "8nYf",
	"./bad/story5.gif": "jmEy",
	"./bad/story6.jpg": "rlqB",
	"./bad/story7.gif": "Ie3F",
	"./bad/story8.jpg": "ss0B",
	"./bad/story9.jpg": "arWJ",
	"./fonts/FontAwesome.otf": "cL3u",
	"./fonts/GroteskDemiBold.eot": "e8+N",
	"./fonts/GroteskDemiBold.ttf": "m9ci",
	"./fonts/GroteskDemiBold.woff": "aO4K",
	"./fonts/GroteskDemiRegular.eot": "EmL9",
	"./fonts/GroteskDemiRegular.ttf": "Qbef",
	"./fonts/GroteskDemiRegular.woff": "AM/3",
	"./fonts/LavaPro-Med.eot": "uSaB",
	"./fonts/LavaPro-Med.otf": "QHAT",
	"./fonts/LavaPro-Med.svg": "dzqj",
	"./fonts/LavaPro-Med.ttf": "bSXe",
	"./fonts/LavaPro-Med.woff": "0GkE",
	"./fonts/LavaPro-MedIta.eot": "JK2J",
	"./fonts/LavaPro-MedIta.otf": "mTTK",
	"./fonts/LavaPro-MedIta.svg": "hdIG",
	"./fonts/LavaPro-MedIta.ttf": "O+ds",
	"./fonts/LavaPro-MedIta.woff": "xXqM",
	"./fonts/LavaPro-Reg.eot": "a9Mq",
	"./fonts/LavaPro-Reg.otf": "/vTW",
	"./fonts/LavaPro-Reg.svg": "lYoC",
	"./fonts/LavaPro-Reg.ttf": "qb0S",
	"./fonts/LavaPro-Reg.woff": "AjSl",
	"./fonts/LavaPro-RegIta.eot": "Pm57",
	"./fonts/LavaPro-RegIta.otf": "Unrg",
	"./fonts/LavaPro-RegIta.svg": "upht",
	"./fonts/LavaPro-RegIta.ttf": "Yqwf",
	"./fonts/LavaPro-RegIta.woff": "nB5G",
	"./fonts/fontawesome-webfont.eot": "aPsI",
	"./fonts/fontawesome-webfont.svg": "VG2H",
	"./fonts/fontawesome-webfont.ttf": "E+mj",
	"./fonts/fontawesome-webfont.woff": "BgeE",
	"./fonts/fontawesome-webfont.woff2": "DwCF",
	"./fox_logo.png": "y/+8",
	"./logo.svg": "AqYs",
	"./main/story1.jpg": "ZFoh",
	"./main/story2.gif": "GTIs",
	"./main/story3.jpg": "hdxX",
	"./main/story4.gif": "2Q+J",
	"./main/story5.jpg": "sKAp",
	"./main/story6.jpg": "GVxf",
	"./main/story7.jpg": "/P/i",
	"./main/story8.jpg": "Jg62",
	"./main/story9.jpg": "jdpp",
	"./rating.svg": "mcgu",
	"./sliders/3/0.jpg": "lhft",
	"./sliders/3/1.jpg": "vt+5",
	"./sliders/3/10.jpg": "JoXa",
	"./sliders/3/11.jpg": "8z8U",
	"./sliders/3/12.jpg": "9I8l",
	"./sliders/3/13.jpg": "l+8c",
	"./sliders/3/2.jpg": "yOrV",
	"./sliders/3/3.jpg": "0iWE",
	"./sliders/3/4.jpg": "hf03",
	"./sliders/3/5.jpg": "IGTt",
	"./sliders/3/6.jpg": "bBQ3",
	"./sliders/3/7.jpg": "8r9z",
	"./sliders/3/8.jpg": "uXgz",
	"./sliders/3/9.jpg": "R/0j",
	"./sliders/5/0.jpg": "P+fR",
	"./sliders/5/1.jpg": "4YmR",
	"./sliders/5/2.jpg": "VBPt",
	"./sliders/5/3.jpg": "If3P",
	"./sliders/5/4.jpg": "IB7f",
	"./sliders/5/5.jpg": "fixS",
	"./sliders/5/6.jpg": "TWu4",
	"./sliders/5/7.jpg": "e4QI",
	"./sliders/5/8.jpg": "bEJR",
	"./sliders/5/9.jpg": "yZ9B",
	"./sliders/7/0.jpg": "PIvm",
	"./sliders/7/1.jpg": "ndTK",
	"./sliders/7/2.jpg": "/S/X",
	"./sliders/7/3.jpg": "+vGv",
	"./sliders/7/4.jpg": "4lbE",
	"./sliders/7/5.jpg": "81UI",
	"./sliders/7/6.jpg": "W5al",
	"./sliders/8/0.jpg": "6mpd",
	"./sliders/8/1.jpg": "wS3B",
	"./sliders/8/10.jpg": "hxWn",
	"./sliders/8/2.jpg": "pXdQ",
	"./sliders/8/3.jpg": "5eU4",
	"./sliders/8/4.jpg": "HKYk",
	"./sliders/8/5.jpg": "9NDC",
	"./sliders/8/6.jpg": "RjVz",
	"./sliders/8/7.jpg": "HDuT",
	"./sliders/8/8.jpg": "4tdN",
	"./sliders/8/9.jpg": "JbHC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0